export const siteMetadata = {
  title: 'Nood - Transform Your Skills',
  description: 'Empowering Moroccan youth to transform their skills into successful careers and businesses through expert-led courses and a supportive community.',
  siteUrl: 'https://nood.edu.ma', // Replace with your actual domain
  siteName: 'Nood',
  logoUrl: '/noodLogoGreen.png', // Assuming this is the path to your logo
  ogImage: '/og-image.png', // Create and add an OG image
} 